'use client';

import React from 'react';
import { useHydrationSafe } from '@/hooks/useHydrationSafe';
import NamePhoneFields from './NamePhoneFields';
import EquipmentSelector from './EquipmentSelector';
import DateSelector from './DateSelector';
import DurationDisplay from './DurationDisplay';
import ProjectDetails from './ProjectDetails';
import SubmitButton from './SubmitButton';
import FormFooter from './FormFooter';

interface FormContentProps {
  formData: {
    name: string;
    phone: string;
    email: string;
    equipment: string;
    startDate: Date | null;
    endDate: Date | null;
    duration: string;
    message: string;
  };
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  handleEquipmentChange: (equipmentType: string) => void;
  handleDateChange: (field: 'startDate' | 'endDate', date: Date | null) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
  isSubmitting: boolean;
  formTitle: string;
}

const FormContent: React.FC<FormContentProps> = ({
  formData,
  handleInputChange,
  handleEquipmentChange,
  handleDateChange,
  handleSubmit,
  isSubmitting,
  formTitle
}) => {
  const { getFormProps } = useHydrationSafe();

  return (
    <>
      <h3 className="text-2xl sm:text-3xl font-black mb-2 text-gray-900">{formTitle}</h3>
      <p className="text-gray-600 mb-6 sm:mb-8 text-sm sm:text-base font-medium">Get a competitive quote in minutes</p>
      
      <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-4" {...getFormProps()}>
        <NamePhoneFields 
          name={formData.name}
          phone={formData.phone}
          email={formData.email}
          handleInputChange={handleInputChange}
        />
        
        <EquipmentSelector
          selectedEquipment={formData.equipment}
          handleEquipmentChange={handleEquipmentChange}
        />

        <DateSelector
          startDate={formData.startDate}
          endDate={formData.endDate}
          handleDateChange={handleDateChange}
        />
        
        <DurationDisplay duration={formData.duration} />
        
        <ProjectDetails
          message={formData.message}
          handleInputChange={handleInputChange}
        />
        
        <SubmitButton isSubmitting={isSubmitting} />
      </form>
      
      <FormFooter />
    </>
  );
};

export default FormContent;